import BaseRepository from '@/baseRepository/BaseRepository';
const currenciesResource = `/api/v1/currencies`;
export default {
    getCurrencies(
      baseURL = {},
      headers = {},
      params = {}
    ) {
      return BaseRepository.get(
        `${currenciesResource}`,
        {
          baseURL,
          headers,
          params,
        }
      );
    }
}